export default "__VITE_ASSET__Drx_08K5__"